import { Eye, Share2, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function FlatfinderWorkspaceHeader({
  busy,
  canDelete,
  projectName,
  onDelete,
  onPreview,
  onShare,
}: {
  busy: boolean;
  canDelete: boolean;
  projectName: string;
  onDelete: () => void;
  onPreview: () => void;
  onShare: () => void;
}) {
  const { t } = useTranslation();

  return (
    <header className="flex flex-wrap items-center justify-between gap-3">
      <h1 className="text-2xl font-semibold">
        {t('flatfinderFormFlatfinder')} · {projectName}
      </h1>
      <div className="flex gap-2">
        <Button
          variant="destructive"
          disabled={busy || !canDelete}
          onClick={onDelete}
          className="gap-2"
        >
          <Trash2 />
          {t('flatfinderFormDeleteFlatfinder')}
        </Button>
        <Button variant="outline" onClick={onPreview} className="gap-2 bg-white">
          <Eye />
          {t('preview')}
        </Button>
        <Button variant="outline" onClick={onShare} className="gap-2 bg-white">
          <Share2 />
          {t('sharing')}
        </Button>
      </div>
    </header>
  );
}
